var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 2.66669H5.33329C3.86663 2.66669 2.67996 3.86669 2.67996 5.33335L2.66663 29.3334L7.99996 24H26.6666C28.1333 24 29.3333 22.8 29.3333 21.3334V5.33335C29.3333 3.86669 28.1333 2.66669 26.6666 2.66669ZM7.99996 12H24V14.6667H7.99996V12ZM18.6666 18.6667H7.99996V16H18.6666V18.6667ZM24 10.6667H7.99996V8.00002H24V10.6667Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat2);
export default __webpack_public_path__ + "static/media/chat2.8b39395450aa1bc205ad924800d72864.svg";
export { ForwardRef as ReactComponent };